import styled, { css } from "styled-components/macro"

export const heading1 = css`
  font-size: 36px;
  font-weight: 300;
`

export const heading2 = css`
  font-size: 26px;
  font-weight: 300;
`

export const heading3 = css`
  font-size: 20px;
  font-weight: 300;
`

export const title = css`
  font-size: 18px;
`

export const body = css`
  font-size: 18px;
  font-weight: 200;
`

export const H1 = styled.h1`
  ${heading1}
`

export const H2 = styled.h2`
  ${heading1}
`
